module.exports = __webpack_public_path__ + "img/ESG.7bdda286.png";